// Public API
export { init } from './instrumentation';
export type { TelemetryConfig } from './instrumentation';
export { Logger, createLogger, getTraceContext } from './logger';
export type { LogLevel } from './logger';
export { CUSTOM_ATTRIBUTES } from './custom-processor';
export { telemetryHttpInterceptorFactory } from './interceptor';
export type { TelemetryHttpInterceptor } from './interceptor';
export { startPageSpan, endPageSpan, markPageLoaded, setPageTab, prepareTabbedPage, getActivePageSpan, getPageContext } from './router';

// Expose on window for AngularJS consumption
import { init } from './instrumentation';
import { Logger, createLogger, getTraceContext } from './logger';
import { CUSTOM_ATTRIBUTES } from './custom-processor';
import { telemetryHttpInterceptorFactory } from './interceptor';
import { startPageSpan, endPageSpan, markPageLoaded, setPageTab, prepareTabbedPage, getActivePageSpan, getPageContext } from './router';

if (typeof window !== 'undefined') {
  (window as any).DxTelemetry = {
    init,
    Logger,
    createLogger,
    getTraceContext,
    CUSTOM_ATTRIBUTES,
    telemetryHttpInterceptorFactory,
    startPageSpan,
    endPageSpan,
    markPageLoaded,
    setPageTab,
    prepareTabbedPage,
    getActivePageSpan,
    getPageContext
  };
}